export default (() => {
  // Get the header element
  const header = document.querySelector('.main-header')

  if (header) { // Check if header is present
    // Add an event listener to check for scroll
    window.addEventListener('scroll', function () {
      // Get the current scroll position
      const scrollY = window.scrollY

      // Check if the scroll position is greater than or equal to 30px
      if (scrollY >= 30) {
        // Add the 'shadow' class to make it appear sticky
        header.classList.add('shadow')
      } else {
        // Remove the 'shadow' class
        header.classList.remove('shadow')
      }
    })
  }
})()
